import React from 'react'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import FormControl from '@material-ui/core/FormControl'
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Radio from '@material-ui/core/Radio'
import QuestionContainer from './QuestionContainer'
import RadioGroup from '@material-ui/core/RadioGroup'
import { injectIntl } from 'react-intl'
import { Field } from 'redux-form'
import { required } from '../../../../utilties/validators'



const TFQuestionForm = ({ showError, input, value, i, label, meta: { touched, invalid, error }, ...rest }) => {
	return (
		<div>
			<FormControlLabel
				data-testid="tf-question-form-label"
				value={value}
				error={touched && invalid}
				helperText={touched && error}
				key={i}
				control={<Radio color="primary" value={i} />}
				labelPlacement='end'
				label={label}
				{...input}
				{...rest}
			/>
			{showError && touched && error && <span data-testid="tf-question-form-error" className="errorWrapper">{error}</span>}
		</div>
	)
}

const TFQuestion = ({ question, position, positionDisplay, intl }) => {
	return (
		<Grid>
			<QuestionContainer
				data-testid="tf-question"
				title={`${question.title}`} titleRequered = {`${question.isOptional ? '' : ' *'}`}
				position={position}
				positionDisplay={positionDisplay}
				instructions={question.instructions}
				children={
					<FormControl component='fieldset' style={{ marginLeft: '-12px' }}>
						<FormGroup>
							<RadioGroup data-testid="tf-question-radio-group">
								<Field
									data-testid="tf-question-radio-field"
									component={TFQuestionForm}
									i='1'
									label={
										<Typography variant='subtitle2'>
											{intl.formatMessage({
												id: 'app.survey.trueAnswer'
											})}
										</Typography>
									}
									// name={
									// 	'answers.' +
									// 	question.questionType +
									// 	'.' +
									// 	question.id
									// }
									name={'answers.tf._' + question.uniqueId}
									value='true'
									validate={required}
									showError={false}
								/>

								<Field
									data-testid="tf-question-form-field"
									component={TFQuestionForm}
									i='0'
									label={
										<Typography variant='subtitle2'>
											{intl.formatMessage({
												id: 'app.survey.falseAnswer'
											})}
										</Typography>
									}
									// name={
									// 	'answers.' +
									// 	question.questionType +
									// 	'.' +
									// 	question.id
									// }
									name={'answers.tf._' + question.uniqueId}
									value='false'
									validate={required}
									showError={true}
								/>
							</RadioGroup>
						</FormGroup>
					</FormControl>
				}
			/>
		</Grid>
	)
}

export default injectIntl(TFQuestion)
